import { useContext } from 'react';
import PodpisPredsedaFormDataContext, {
  PodpisPredsedaFormDataContextContent,
} from '../PodpisPredsedaFormDataContext';

export default ():
  PodpisPredsedaFormDataContextContent => useContext(PodpisPredsedaFormDataContext);
